program stfmsweb;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  Bcl.Utils,
  stfmssystem.login in 'system\stfmssystem.login.pas'{*.html},
  stfmssystem.connection in 'system\stfmssystem.connection.pas',
  share.classes in '..\xdata\share\share.classes.pas',
  settings.useraccess in 'settings\settings.useraccess.pas'{*.html},
  settings.useraccesssetup in 'settings\settings.useraccesssetup.pas'{*.html},
  share.common in 'share\share.common.pas',
  settings.usercopyrights in 'settings\settings.usercopyrights.pas'{*.html},
  planning.enquiry in 'loads\planning\planning.enquiry.pas'{*.html},
  search.subs in 'search\search.subs.pas'{*.html},
  vehicle.details in 'loads\transactions\vehicle.details.pas'{*.html},
  search.vehgroups in 'search\search.vehgroups.pas'{*.html},
  search.controller in 'search\search.controller.pas'{*.html},
  search.reg in 'search\search.reg.pas'{*.html},
  diesel.fuelorders.create in 'diesel\transactions\diesel.fuelorders.create.pas'{*.html},
  diesel.fuelorders.enquiry in 'diesel\transactions\diesel.fuelorders.enquiry.pas'{*.html},
  search.subsdiesel in 'search\search.subsdiesel.pas'{*.html},
  assets.settings.budgetsownfleet in 'assets\settings\assets.settings.budgetsownfleet.pas'{*.html},
  assets.settings.budgetownfleet.maintenance in 'assets\settings\assets.settings.budgetownfleet.maintenance.pas'{*.html},
  share.messagebox in 'share\share.messagebox.pas'{*.html},
  URemoteSupport in 'system\URemoteSupport.pas'{*.html},
  USGCompLink in 'system\USGCompLink.pas'{*.html},
  USGGLLink in 'system\USGGLLink.pas'{*.html},
  USGTaxLink in 'system\USGTaxLink.pas'{*.html},
  USGBankLink in 'system\USGBankLink.pas'{*.html},
  USMSUser in 'system\USMSUser.pas'{*.html},
  USystemPeriods in 'system\USystemPeriods.pas'{*.html},
  UCutOffDate in 'system\UCutOffDate.pas'{*.html},
  UChangepassword in 'system\UChangepassword.pas'{*.html},
  SystemAutoMailSetup in 'system\SystemAutoMailSetup.pas'{*.html},
  SystemAutoMailView in 'system\SystemAutoMailView.pas'{*.html},
  share.system.classes in '..\xdata\share\share.system.classes.pas',
  SystemCostGroupsView in 'system\SystemCostGroupsView.pas'{*.html},
  SystemCostGroupsSetup in 'system\SystemCostGroupsSetup.pas'{*.html},
  dashboard.maintenance in 'dashboards\dashboard.maintenance.pas'{*.html},
  SystemCostGroupDetailEdit in 'system\SystemCostGroupDetailEdit.pas'{*.html},
  SystemInvoiceNumberSetup in 'system\SystemInvoiceNumberSetup.pas'{*.html},
  SystemSetupVatSetup in 'system\SystemSetupVatSetup.pas'{*.html},
  SystemGeneralLedgerAccountsSetup in 'system\SystemGeneralLedgerAccountsSetup.pas'{*.html},
  SystemLedgerAccountSetup in 'system\SystemLedgerAccountSetup.pas'{*.html},
  dashboard.loads in 'dashboards\dashboard.loads.pas'{*.html},
  dashboard.loads.controller in 'dashboards\dashboard.loads.controller.pas'{*.html},
  dashboard.loads.notinvoiced in 'dashboards\dashboard.loads.notinvoiced.pas'{*.html},
  SystemSettings in 'system\SystemSettings.pas'{*.html},
  SystemTFNSubAccountsSetup in 'system\SystemTFNSubAccountsSetup.pas'{*.html},
  FMSFuelSystemSetup in 'system\FMSFuelSystemSetup.pas'{*.html},
  search.TranType in 'search\search.TranType.pas'{*.html},
  Search.SystemTypes in 'search\Search.SystemTypes.pas'{*.html},
  Search.FleetTypes in 'search\Search.FleetTypes.pas'{*.html},
  Search.ValueTypes in 'search\Search.ValueTypes.pas'{*.html},
  Search.GLAccounts in 'search\Search.GLAccounts.pas'{*.html},
  dashboard.loads.outstanding in 'dashboards\dashboard.loads.outstanding.pas'{*.html},
  stfmssystem.main in 'system\stfmssystem.main.pas',
  search.dieseldepots in 'search\search.dieseldepots.pas'{*.html} {*.html},
  DieselAttendants in 'diesel\setup\DieselAttendants.pas'{*.html},
  DieselAttendantSetup in 'diesel\setup\DieselAttendantSetup.pas'{*.html},
  DieselDepotPricesSetup in 'diesel\setup\DieselDepotPricesSetup.pas'{*.html},
  DieselDepots in 'diesel\setup\DieselDepots.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  DefaultTimeZoneMode := TTimeZoneMode.AsLocal;
  Application.CreateFormDirect(TdmData, dmData);
  Application.CreateForm(Tfrmmain, frmmain);
  Application.CreateForm(TfrmSearchDieselDepots, frmSearchDieselDepots);
  Application.CreateForm(TfrmFuelAttendants, frmFuelAttendants);
  Application.CreateForm(TfrmDieselAttendantSetup, frmDieselAttendantSetup);
  Application.CreateForm(TfrmDepotPriceSetup, frmDepotPriceSetup);
  Application.CreateForm(TfrmDieselDepots, frmDieselDepots);
  Application.Run;
end.
